import { useCallback, useMemo, useState } from 'react'
import { isMobileDevice } from '../../../shared/utils/isMobileDevice'

/**
 * Guard for GAME activity entry points on phones/tablets.
 *
 * Game activities (Whereby lobby + Unity game) are desktop-only. Wrap any
 * "enter the game" action with `guardGameEntry` — on desktop the action runs
 * unchanged; on a mobile device it is swallowed and the desktop-only modal
 * opens instead. Non-game activities must NOT go through this guard.
 */
export const useMobileGameGuard = () => {
  // UA never changes during a session — evaluate once per mount.
  const isMobile = useMemo(() => isMobileDevice(), [])
  const [isDesktopOnlyModalOpen, setIsDesktopOnlyModalOpen] = useState(false)

  const guardGameEntry = useCallback(
    (enterGame: () => void) => {
      if (isMobile) {
        setIsDesktopOnlyModalOpen(true)
        return
      }
      enterGame()
    },
    [isMobile]
  )

  const openDesktopOnlyModal = useCallback(() => setIsDesktopOnlyModalOpen(true), [])
  const closeDesktopOnlyModal = useCallback(() => setIsDesktopOnlyModalOpen(false), [])

  return { isMobile, isDesktopOnlyModalOpen, guardGameEntry, openDesktopOnlyModal, closeDesktopOnlyModal }
}
